import RequestUrl from '@/services/api/requestUrl';
import { BaseGet, BasePost, BasePut } from '@/services/net/request';
// 引入公共接口
export * from '@/services/api/commonApi';



// 获取用户账户类型 0 sar 1 usd
export async function getUserAccountTypeApi(data: any) {
  return  BaseGet(RequestUrl.getUserAccountTypeUrl);
}

/**
 * 一键认购 FPO
 */
export async function buySubscriptionAllFPO(params: any) {
  return BaseGet(RequestUrl.oneClickSubscriptionFPO, params);
}
